import { GetExtension } from "./GetExtension";

export function StripExtension(fileName) {
  if (fileName == null) return "";

  var fileExt = GetExtension(fileName);
  var l = fileExt.length;
  if (l > 0) l++;
  var n = fileName.length - l;
  return fileName.substring(0, n);
}
